// extracted by mini-css-extract-plugin
module.exports = {"Slot":"OperationalDefinitions_Slot__XvkpX","AddButtonContainer":"OperationalDefinitions_AddButtonContainer__2_GSy"};